import {
  Box,
  SimpleGrid,
  Text,
  Flex,
  Spacer,
  Radio,
  RadioGroup,
  Stack,
  Card,
  CardHeader,
  Image,
} from "@chakra-ui/react";

import NewsSection from "./NewsSection";
import { useState, useEffect } from "react";
import { getUser } from "../authConfig";

const Dashboard = () => {
  const [selectedValue, setSelectedValue] = useState("my-overview");
  const [username, setUsername] = useState("");

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const user = await getUser(); 
        if (user && user.profile) {
          setUsername(user.profile.name || "User"); 
        }
      } catch (error) {
        console.error("Error fetching user:", error);
      }
    };

    fetchUser();
  }, []);

  return (
    <Box flex="1" pt="78px" px="8">
      <Flex  direction={{ base: "column", md: "row" }}>
        <Text fontSize="30px" color="#101828">
          Welcome, {username}
        </Text>
        <Spacer />

        <RadioGroup
          onChange={setSelectedValue}
          value={selectedValue}
          display="Flex"
          color="#475467"
        >
          <Stack direction="row" color="#475467">
            <Radio
              value="my-overview"
              mr="20px"
              
            >
              <Text fontSize="12px">My overview</Text>
            </Radio>
            <Radio
              value="team-overview"
              color="#475467"
            >
               <Text fontSize="12px">Team overview</Text>
            </Radio>
          </Stack>
        </RadioGroup>
      </Flex>

      {/* Actions */}
      <Text mt={4} color="#101828" fontSize="16px">
        Your actions
      </Text>
      <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing={5} mt={2}>
        {[
          { title: "Open requests", count: 10, newCount: 1 },
          { title: "Open jobs", count: 23, newCount: 12 },
          { title: "Pending approvals", count: 10, newCount: 3 },
          { title: "Stock alerts ", count: 52, newCount: 2 },
        ].map((item, index) => (
          <Card
            key={index}
            style={{ borderColor: "#d0d5dd", borderWidth: "1px", boxShadow:"none", padding:"14px 18px 16px 18px" }}
          >
            <CardHeader display="flex" justifyContent="space-between" p={0} color="#475467" fontSize="14px">
              {item.title}
              <Image src="/svg/arrow.svg" w="20px" h="20px" />
            </CardHeader>

            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              
            >
              <Text fontSize="34px" color="#475467">{item.count}</Text>
              {item.newCount > 0 && (
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  width="73px"
                  height="24px"
                  borderRadius="16px"
                  border="1px solid #ddebd5"
                  backgroundColor="#f8fcf8"
                  boxSizing="border-box"
                  marginTop="13px"
                >
                  <Text fontSize="sm" color="green.700">
                    {item.newCount} new
                  </Text>
                </Box>
              )}
            </Box>
          </Card>
        ))}
      </SimpleGrid>




     {/* Wins */}
     <Text mt="56px" color="#101828" fontSize="16px">
     Your wins this week
      </Text>
      <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing={5} mt={2}>
        {[
          { title: "Converted requests", count: 24},
          { title: "Completed jobs", count: 24},
          { title: "Quoted items", count: 167},
          { title: "Stock replenished", count: 20000},
        ].map((item, index) => (
          <Card
            key={index}
            style={{ borderColor: "#d0d5dd", borderWidth: "1px", boxShadow:"none", padding:"14px 18px 16px 18px" }}
          >
            <CardHeader display="flex" justifyContent="space-between" p={0} color="#475467" fontSize="14px">
              {item.title}
            </CardHeader>

            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              
            >
              <Text fontSize="34px" color="#475467">{item.count.toLocaleString()}</Text>
              {item.newCount > 0 && (
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  width="73px"
                  height="24px"
                  borderRadius="16px"
                  border="1px solid #ddebd5"
                  backgroundColor="#f8fcf8"
                  boxSizing="border-box"
                >
                  <Text fontSize="sm" color="green.700">
                    {item.newCount} new
                  </Text>
                </Box>
              )}
            </Box>
          </Card>
        ))}
      </SimpleGrid>







     

      {/* News Section */}
      <NewsSection />
    </Box>
  );
};

export default Dashboard;
